import { useSuspenseQuery } from '@tanstack/react-query';
import qs from 'qs';
import apiClient from '@/lib/apiClient';

// https://fss-gateway.c2fo.com
// /api/c2fo/taker/3563147/market/61af100a-d391-4afe-832b-4d4a0e0bb8a1/invoices/awarded/stats
// ?filter=%7B%7D

export interface AwardedInvoiceStats {
  count: number | null;
  subTotal: number | null;
}

export interface AwardedInvoiceStatFetchOptions {
  includeOnlyPendingManualAward?: boolean;
}

const fetchAwardedInvoiceStats = async ({
  marketId,
  takerId,
  options,
}: {
  marketId: string;
  takerId: number;
  options: Partial<AwardedInvoiceStatFetchOptions>;
}): Promise<AwardedInvoiceStats> => {
  const params = qs.stringify(
    {
      filter: options.includeOnlyPendingManualAward ? { isCleared: false, isPendingClear: false } : undefined,
    },
    { addQueryPrefix: true }
  );
  return apiClient
    .get(`api/c2fo/taker/${takerId}/market/${marketId}/invoices/awarded/stats${params}`)
    .json<AwardedInvoiceStats>();
};

const useAwardedInvoiceStats = (params: {
  marketId: string;
  takerId: number;
  options: Partial<AwardedInvoiceStatFetchOptions>;
}) => {
  const { marketId, takerId, options } = params;

  return useSuspenseQuery({
    queryKey: ['awarded-invoice-stats', marketId, takerId, options],
    queryFn: () =>
      !!marketId && !!takerId
        ? fetchAwardedInvoiceStats({
            marketId,
            takerId,
            options,
          })
        : null,
  });
};

export default useAwardedInvoiceStats;
